module.exports = __webpack_public_path__ + "static/media/target.931737ef.png";